import React, {useEffect} from "react";
import { Link } from "react-router-dom"
import CloseImage from "../assets/images/close.svg";
import "../assets/css/modal.css";

function FrameModal(props) {
    const campaignUrl = props.campaignUrl;

    // Modal Analytics
    useEffect(() => {
        if (window._satellite) {
            if (props.title) {
                let data = {
                    modalName: "nba:membership-hub:benefits-detail",
                    contentTitle: props.title,
                    contentID: "",
                    contentType: "benefit",
                };
                window._satellite.track("modal-display", data);
                console.log("Reward Modal: analytics added");
            }
        }
    }, [props]);

    let renderIFrame = () => {
        const link = campaignUrl;
        return (
            <iframe
                id="modal-iframe"
                src={link}
                className="jebbit-iframe"
                style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "80vh",
                    border: "0px"
                }}
                seamless={true}
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                allowFullScreen={true}
                frameBorder="0"
                title="Voting"
                allow="clipboard-read; clipboard-write"
                onLoad={() => {
                }}>
            </iframe>
        );
    };

    return (
        <div className="modal-container jebbit-container">
            <div className="modal-background">
            </div>
            <div className="modal-dialog jebbit-dialog">
                <div className="modal-header">
                    {props.overview ?
                        <button className="modal-close" onClick={() => {
                            props.closeModal();
                        }}>
                            <img alt="close" src={CloseImage}/>
                        </button>
                        :
                        <Link
                            to={{ pathname: "/voting", search: window.location.search }}
                            className="modal-close"
                            data-track="click"
                            data-id="nba:membership-hub:dismiss"
                            data-section="voting"
                            data-type="dismiss"
                            onClick={() => { props.setShowModal(false) }}>
                            <img alt="close" src={CloseImage} />
                        </Link>
                    }
                </div>
                <div className="modal-body jebbitModal">
                    {renderIFrame()}
                </div>
            </div>
        </div>
    );
}

export default FrameModal;
